export default "__VITE_ASSET__IVnTsvHh__"